import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("sn_lang") || "lt");

  const setLanguage = useCallback((l) => {
    localStorage.setItem("sn_lang", l);
    setLang(l);
  }, []);

  const toggle = useCallback(() => {
    setLanguage(lang === "lt" ? "en" : "lt");
  }, [lang, setLanguage]);

  // t("nav.home") style getter
  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let node = translations[lang];
      for (const p of parts) {
        if (node == null) return path;
        node = node[p];
      }
      return node == null ? path : node;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLanguage, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
